import { render, staticRenderFns } from "./featured-products.vue?vue&type=template&id=bb4a0934&scoped=true"
import script from "./featured-products.vue?vue&type=script&lang=js"
export * from "./featured-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4a0934",
  null
  
)

export default component.exports